import { ReactNode } from 'react'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SidebarPluginState {
  children: ReactNode
}

const initialState: SidebarPluginState = {
  children: null,
}

export const sidebarPluginSlice = createSlice({
  name: 'sidebarPlugin',
  initialState,
  reducers: {
    setSidebarPluginChildren(state, { payload }: PayloadAction<ReactNode>) {
      state.children = payload
    },
  },
})

export const { setSidebarPluginChildren } = sidebarPluginSlice.actions

export default sidebarPluginSlice.reducer
